declare const value: string;

// $ExpectError
value;
